import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import React from 'react'
import { useIntl } from 'react-intl'
import List from 'components/Common/List/List'

function FlexibleCancellationCharterFlightFees() {
  const intl = useIntl()

  return <Group direction="vertical" gap={8}>
    <div>
      <BodyText variant="medium" weight="bold">
        {intl.formatMessage({
          id: '1I7bQqZ_GCisK4YzPkmH',
          defaultMessage: 'Date changes',
          description: 'Heading for date changes section in charter flight cancellation fees',
        })}
      </BodyText>
      <BodyText variant="medium">
        {intl.formatMessage({
          id: '2LHBDhP77xkrAnCD7FCq',
          defaultMessage: 'One change permitted up to 21 days prior to departure. Subject to availability and a change fee.',
          description: 'Policy text about date change permissions for charter flights',
        })}
      </BodyText>
      <List type="ul">
        <BodyText variant="medium" as="li">
          {intl.formatMessage({
            id: 'Elt8FpC4c3kPV0ndFKbI',
            defaultMessage: 'Economy: $200 change fee per person',
            description: 'Economy class date change fee for charter flights in the flights section',
          })}
        </BodyText>
        <BodyText variant="medium" as="li">
          {intl.formatMessage({
            id: 'AqaNfyWPedL7NLfDinT6',
            defaultMessage: 'Business: $500 change fee per person',
            description: 'Business class date change fee for charter flights',
          })}
        </BodyText>
      </List>
    </div>

    <BodyText variant="medium">
      {intl.formatMessage({
        id: 'oy-6v5ej4IvpDBgUeij9',
        defaultMessage: 'Additional change fees may apply for peak periods or property-specific surcharges.',
        description: 'Additional change fee disclaimer for charter flights',
      })}
    </BodyText>

    <div>
      <BodyText variant="medium" weight="bold">
        {intl.formatMessage({
          id: 'hfGUkW472BU4QjhCYBS-',
          defaultMessage: 'Cancellations',
          description: 'Heading for cancellations section in charter flight cancellation fees',
        })}
      </BodyText>
      <BodyText variant="medium">
        {intl.formatMessage({
          id: 'OKPcfkdAsqn1IpIe4i3e',
          defaultMessage: 'Cancellations made during this period will incur the following fees:',
          description: 'Introduction to cancellation fees list for charter flights',
        })}
      </BodyText>
      <List type="ul">
        <BodyText variant="medium" as="li">
          {intl.formatMessage({
            id: 'p4gggGC96TNOqVMCkkXk',
            defaultMessage: 'Economy: $995 per person',
            description: 'Economy class cancellation fee for charter flights',
          })}
        </BodyText>
        <BodyText variant="medium" as="li">
          {intl.formatMessage({
            id: 'tBIa7unhMnOevkK540Vy',
            defaultMessage: 'Business: $2,995 per person',
            description: 'Business class cancellation fee for charter flights',
          })}
        </BodyText>
      </List>
    </div>

    <BodyText variant="medium">
      {intl.formatMessage({
        id: 'mi-dNXTPVMnS9Ydu9-FP',
        defaultMessage: 'The remaining balance, after deduction of the applicable cancellation fees, will be refunded to your original payment or credit.',
        description: 'Refund information after cancellation fee deduction for charter flights',
      })}
    </BodyText>
  </Group>
}

export default FlexibleCancellationCharterFlightFees
